import Vuex from "vuex";
import Vue from "vue";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    auth: {
      loggedIn: false,
      username: "",
      realname: ""
    },
    picklists: {
      openPicklist: [],
      workingPicklist: [],
      donePicklist: []
    },
    pick: {
      id: "",
      pixi_id: "",
      items: [],
      open: [],
      done: [],
      current: {},
      count: 0,
      isFinished: false,
    },
    missingCounts: [],
  },
  getters: {
    connectedUser: state => {
      return state.auth.username;
    }
  },
  mutations: {
    userChanged(state, user) {
      state.auth.loggedIn = true;
      state.auth.username = user.username;
      state.auth.realname = user.realname;
    },
    setPicklist(state, picklist) {
      state.picklists.openPicklist = picklist.openPicklist;
      state.picklists.workingPicklist = picklist.workingPicklist;
      state.picklists.donePicklist = picklist.donePicklist;
    },
    setCurrentPickOpen(state, pickDetail) {
      state.pick.id = pickDetail.id
      state.pick.pixi_id = pickDetail.pixi_id;
      state.pick.items = pickDetail.items;
      state.pick.open = pickDetail.open;
      state.pick.done = pickDetail.done;
      state.pick.current = pickDetail.pick;
      state.pick.count = 0;
      state.pick.isFinished = false;
    },
    setCurrentPickStatus(state, pickStatus) {
      state.pick.open = pickStatus.open;
      state.pick.done = pickStatus.done;
      state.pick.current = pickStatus.pick;
      state.pick.count = pickStatus.count;
      state.pick.isFinished = pickStatus.isFinished;
    },

    resetCurrentPick(state) {
      state.pick.id = ""
      state.pick.pixi_id = "";
      state.pick.items = [];
      state.pick.open = [];
      state.pick.done = [];
      state.pick.current = {};
      state.pick.count = 0;
      state.pick.isFinished = false;
    },

    setMissingCounts(state, missingCounts) {
      state.missingCounts = missingCounts;
    },
  },
  actions: {

    userChanged(context, user) {
      context.commit("userChanged", user);
    },

    setPicklist(context, picklist) {
      const openPicklist = [];
      const workingPicklist = [];
      const donePicklist = [];

      picklist.forEach(picklistItem => {
        if (!picklistItem.id && !picklistItem.in_progress) {
          openPicklist.push(picklistItem);
        } else if (picklistItem.in_progress === 1) {
          workingPicklist.push(picklistItem);
        } else if (picklistItem.in_progress === 0) {
          donePicklist.push(picklistItem);
        }
      });

      context.commit("setPicklist", {
        openPicklist,
        workingPicklist,
        donePicklist
      });
    },

    setCurrentPick(context, pickDetail) {
      context.commit("setCurrentPickOpen", pickDetail);
    },

    setCurrentPickStatus(context, pickStatus) {
      context.commit("setCurrentPickStatus", pickStatus);
    },

    setMissingCounts(context, missingCounts) {
      context.commit("setMissingCounts", missingCounts);
    },

    resetCurrentPick(context) {
      context.commit("resetCurrentPick");
    }
  }
});
